export default __webpack_public_path__ + "static/media/grafema_angura_12.5cdb0819.jpg";